import { Checkbox } from "vant";

// 禁止iOS双击缩放
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  var lastTouchEnd = 0;
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
}
// 解决安卓手机浏览器软键盘弹起将底部tabbar顶起来
var originalHeight = document.documentElement.clientHeight || document.body.clientHeight;
window.onresize = function () {
  //键盘弹起与隐藏都会引起窗口的高度发生变化
 
  var resizeHeight = document.documentElement.clientHeight || document.body.clientHeight;
  if (resizeHeight - 0 < originalHeight - 0) {
    //当软键盘弹起，在此处操作
    setTimeout(()=> {
      document.querySelector(".footer").setAttribute('style','visibility:hidden');
      document.querySelector(".count-wrap").setAttribute('style','visibility:hidden');
    }, 1000) 
  } else {
    setTimeout(()=> {
      //当软键盘收起，在此处操作
      document.querySelector(".footer").setAttribute('style','visibility.visible');
      document.querySelector(".count-wrap").setAttribute('style','visibility.visible');
    }, 1000)
  }
}



